import { useQuery } from '@tanstack/react-query'
import { LayoutDashboard, Monitor } from 'lucide-react'
import { useAuth } from '../store/auth'
import { PlateChromeProvider, usePlateChrome } from '../store/plateChrome'
import { GlobalButtonsBar } from './PlateLayout'
import { getOpenPlates } from '../api/brainer'
import { AppLayout } from './layout/AppLayout'
import { UserMenu } from './layout/UserMenu'
import type { BPlate } from '../types'

export function OpenPlaceLayout() {
  return (
    <PlateChromeProvider>
      <OpenPlaceLayoutInner />
    </PlateChromeProvider>
  )
}

// OpenPlace shell — TailAdmin AppLayout, the sidebar listing every published dashboard.
function OpenPlaceLayoutInner() {
  const { user } = useAuth()
  const chrome = usePlateChrome()

  const { data: plates = [] } = useQuery({
    queryKey: ['openplace-plates', user?.businessId],
    queryFn: () => getOpenPlates().then(r => r.data),
    enabled: !!user,
  })

  const items = (plates as BPlate[]).map(plate => ({ to: `/open/${plate.id}`, label: plate.name, icon: LayoutDashboard }))

  return (
    <AppLayout
      brand={{ name: 'OpenPlace', icon: Monitor }}
      homeTo={items[0]?.to ?? '/open'}
      sections={items.length ? [{ title: 'Dashboards', items }] : []}
      sidebarEmptyMessage="No dashboards available"
      headerLeft={chrome?.headerTitle && <h1 className="truncate text-lg font-semibold text-gray-800">{chrome.headerTitle}</h1>}
      headerRight={
        <>
          {chrome && <GlobalButtonsBar buttons={chrome.globalButtons} runInputs={chrome.runInputs} />}
          <UserMenu showProfile={false} />
        </>
      }
    />
  )
}
